import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PropTypes from "prop-types";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import { AuthContext } from "../../../context/Auth";

import {
  Box,
  Drawer,
  Hidden,
  List,
  Button,
  ListSubheader,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
  useTheme,
} from "@mui/material";
import NavItem from "./NavItem";
import { RxCrossCircled } from "react-icons/rx";

const useStyles = (theme) => ({
  mobileDrawer: {
    width: 256,
    background: "linear-gradient(90deg, #003161, #003161)",
    position: "fixed",
  },
  desktopDrawer: {
    "& .MuiPaper-root": {
      backgroundColor: "red",
    },
    zIndex: "1",
    marginTop: "70px !important",
    top: "76px",
    width: "260px",
    height: "calc(100% - 125px)",
    margin: "5px 10px 10px 15px",
    background: "linear-gradient(135deg, #003161, #003161)",
    position: "fixed",
    boxShadow: "0px 0px 53px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
    marginLeft: "13px",
  },
  logoutButton: {
    color: "#fff",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    position: "absolute",
    bottom: "5px",
    left: "17px",
    background: "#fff",
    fontWeight: "400",
    fontSize: "13px",
  },
  dialog: {
    "& .MuiDialog-paper": {
      background: "white !important",
    },
  },
  logoutimgicon: {
    border: "1px solid white",
    background: "white",
    color: "red",
    width: "100px",
    height: "70px",
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// import statements

const NavBar = ({ onMobileClose, openMobile, tabView, setSelectedTab }) => {
  const classes = useStyles();
  const location = useLocation();
  const [isLogout, setIsLogout] = useState(false);
  const { handleLogOut } = useContext(AuthContext);
  const theme = useTheme()
  // const handleLogOut = () => {
  //   sessionStorage.removeItem("adminToken");
  //   navigate("/");
  // };


  const sections = [
    {
      items: [
        {
          title: "Overview Dashboard",
          icon: DashboardOutlinedIcon,
          href: "/dashboard",
          tabview: "Arbitrage",
        },
        {
          title: "Clinical Dashboard",
          icon: SupervisorAccountOutlinedIcon,
          href: "/patient-management",
          tabview: "Arbitrage",
        },
        {
          title: "Settings",
          icon: SupervisorAccountOutlinedIcon,
          href: "/settings",
          tabview: "Arbitrage",
        },
 
      ],
    },
  ];

  const renderNavItems = ({ items, pathname, depth = 0, setSelectedTab }) => (
    <List disablePadding>
      {items?.map((item) => {
        const key = item.title + depth;
        const isActive = pathname.includes(item.href);
        return item.items ? (
          <NavItem
            depth={depth}
            icon={item.icon}
            info={item.info}
            key={key}
            open={Boolean(isActive)}
            title={item.title}
            isActive={isActive}
          >
            {renderNavItems({
              depth: depth + 1,
              pathname,
              items: item.items,
              setSelectedTab,
            })}
          </NavItem>
        ) : (
          <NavItem
            depth={depth}
            href={item.href}
            icon={item.icon}
            info={item.info}
            key={key}
            title={item.title}
            setSelectedTab={(item) => setSelectedTab(item)}
            isActive={isActive}
          />
        );
      })}
    </List>
  );

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box pt={2} pb={2}>
          <Box className="sideMenuBox">
            {sections.map((section, i) => (
              <List
                key={`menu${i}`}
                subheader={
                  <ListSubheader disableGutters disableSticky>
                    {section.subheader}
                  </ListSubheader>
                }
              >
                {renderNavItems({
                  items: section.items,
                  pathname: location.pathname,
                  setSelectedTab,
                })}
              </List>
            ))}
          </Box>
        </Box>
        <Button
          onClick={() => setIsLogout(true)}
          className={classes.logoutButton}
          color="secondary"
          style={{
          
            textAlign: "center",
            fontWeight: "400",
            textTransform: "capitalize",
            position: "absolute",
            left: "25px",
            bottom: "25px",
          }}
        >
          <ExitToAppIcon style={{ marginRight: "5px" }} />
          &nbsp; Logout
        </Button>
        {isLogout && (
          <Dialog
            maxWidth="xs"
            fullWidth
            className={classes.dialog}
            open={isLogout}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setIsLogout(false)}
          >
            <DialogContent>
              <Box className={classes.dialougTitle} align="center">
                <Box>
                  <RxCrossCircled className={classes.logoutimgicon} />
                </Box>
                <Typography
                  variant="h4"
                  color="secondary"
                  style={{ color: "black" }}
                >
                  LOGOUT
                </Typography>
                <Typography
                  variant="h6"
                  color="secondary"
                  style={{ marginTop: "20px", color: "black" }}
                >
                  Are you sure you want to logout?
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <Box mt={2} style={{ marginTop: "20px" }}>
                <Button
                  className="modelbtn"
                  variant="containedPrimary"
                  onClick={() => setIsLogout(false)}
                >
                  No
                </Button>
                &nbsp; &nbsp;
                <Button
                  className="modelbtnyes"
                  variant="containedPrimary"
                  onClick={() => handleLogOut()}
                >
                  Yes
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
        )}
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          open={openMobile}
          onClose={onMobileClose}
          variant="temporary"
          sx={{
            "& .MuiPaper-root": {
              background: theme.palette.primary.main,
              color: "#000", 
            },
          }}
        >
          <Box pt={2} pb={2}>
            {content}
          </Box>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
          color="secondary"
          sx={{
            "& .MuiPaper-root": {
              marginTop: "89px !important",
              background: theme.palette.primary.main,
              // boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.05)",
              borderRadius: "10px",
              width: "260px",
              height: "calc(100% - 125px)",
              margin: "5px 4px 10px 8px",
              position: "fixed",
            },
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  setSelectedTab: PropTypes.func.isRequired,
};

export default NavBar;
